import { IEventWebHookAllowedMethod } from 'core/interfaces/IEventWebHooks';

export const WEBHOOK_METHODS: IEventWebHookAllowedMethod[] = ['POST', 'PUT', 'PATCH'];
